import React, { useEffect, useState } from "react";
import { formatDate } from "../../Utils/helper";
import { convertToLocalTime } from "../../Utils/helper";
import { open_api_with_cookies } from "../../Utils/network";
import ToggleButton from "../../components/Button/ToggleButton";
import SideBarDialog from "../../components/Dialog/SideBarDialog";
import redirect from "../../assets/Icons/redirect.svg";
import copy from "../../assets/Icons/copy.svg";
import { Link } from "react-router-dom";
import "./CouponDetails.css";

const AddCoupon = ({ onClose, expertId, couponId }) => {
  const [details, setDetails] = useState({});
  const [isactive, setActive] = useState();
  const [packages, setPackages] = useState([]);
  const [workshops, setWorkshops] = useState([]);
  const [text, setText] = useState("");
  const handleToggle = async () => {
    try {
      const result = await open_api_with_cookies.patch(
        `/coupon/dashboard/update/${couponId}/`,
        { is_visible: !isactive }
      );
      setActive(result.is_visible);
    } catch (error) {
      console.error("Error updating toggle state:", error);
    }
  };

  const getCouponDetails = async () => {
    const result = await open_api_with_cookies.get(
      `coupon/dashboard/detail/${couponId}/?expert_id=${expertId}`
    );

    if (
      (result.status === 200 || result.status === 201) &&
      result.data !== null &&
      result.data !== undefined
    ) {
      console.log(result.data);
      setDetails(result.data);
      setActive(result.data.is_visible);
      setPackages(result.data.session_packages);
      setWorkshops(result.data.workshops);
      setText(result.data.code);
    }
  };

  const handleCopy = async () => {
    try {
      await window.navigator.clipboard.writeText(text);
      alert("Copied to clipboard!");
    } catch (e) {
      alert("Copy to clipboard failed.");
    }
  };

  useEffect(() => {
    getCouponDetails();
  }, [isactive]);

  return (
    <>
      <div className="container-wrapper">
        <SideBarDialog
          isVisible={true}
          onClose={onClose}
          title={`${details.code} Coupon Details`}
        >
          <section className="details-container">
            <section className="left-section">
              <p className="items">
                <span className="span-item">Coupon Code</span>
                <span className="coupon-holder" onClick={handleCopy}>
                  {details.code}
                  <img src={copy} />
                </span>
              </p>
              <p className="items">
                <span className="span-item">Discount Type</span>
                {details.discount_type}
              </p>
              <p className="items">
                <span className="span-item">Discount</span>{" "}
                {details.discount_type === "Amount"
                  ? `₹${details.discount} / ${details.discount_usd || 0}`
                  : details.discount_type === "Percentage"
                  ? `${details.discount}%`
                  : `${details.discount}up to ₹${details.upto_amt}/$${details.upto_amt_usd}`}
              </p>
              <p className="items">
                <span className="span-item">Valid From</span>
                <span className="date-time">
                  {formatDate(details.from_date)}
                  <span>{convertToLocalTime(details.from_date)}</span>
                </span>
              </p>
              <p className="items">
                <span className="span-item">Valid To</span>
                <span className="date-time">
                  {formatDate(details.to_date)}
                  <span>{convertToLocalTime(details.to_date)}</span>
                </span>
              </p>
              <p className="items">
                <span className="span-item">Active</span>
                <ToggleButton isToggled={isactive} onToggle={handleToggle} />
              </p>
            </section>
            <section className="right-section">
              <h4 className="package-header">
                This Coupon is Applicable for the following packages
              </h4>
              {packages.map((element, index) => (
                <section key={index} className="coupons-details">
                  <p className="items">{element.title}</p>
                  <Link
                    className="items"
                    to={`https://www.myburgo.com/bookings/${details.expert_slug}/details?packageId=${element.id}`}
                  >
                    <img src={redirect} className="img-redirect" />
                  </Link>
                </section>
              ))}
            </section>
            <section className="right-section">
              <h4 className="package-header">
                This Coupon is Applicable for the following workshops
              </h4>
              {workshops.map((element, index) => (
                <section key={index} className="coupons-details">
                  <p className="items">{element.title}</p>
                  <Link
                    className="items"
                    to={`https://www.myburgo.com/experts/${element.slug}/workshop/${element.slug}?utm_source=dashboard`}
                  >
                    <img src={redirect} className="img-redirect" />
                  </Link>
                </section>
              ))}
            </section>
          </section>
        </SideBarDialog>
      </div>
    </>
  );
};

export default AddCoupon;
